export const PILL_CLEARANCE_MARGIN_PX = 24
export const UPGRADE_DELAY_MS = 3000
